import { render, staticRenderFns } from "./AdminAuditLogs.vue?vue&type=template&id=17e826b5"
import script from "./AdminAuditLogs.vue?vue&type=script&lang=js"
export * from "./AdminAuditLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports